var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var Role = /** @class */ (function (_super) {
    __extends(Role, _super);
    function Role() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Role.prototype.getId = function () {
        return Number(this.id);
    };
    Role.prototype.getName = function () {
        return this.name;
    };
    Role.prototype.setName = function (name) {
        this.name = name;
    };
    Role.prototype.getPermissionIds = function () {
        return this.default_permission_ids;
    };
    Role.prototype.setPermissionIds = function (permissionIds) {
        this.default_permission_ids = permissionIds;
    };
    return Role;
}(Model));
export default Role;
